//import { mapActions, mapGetters, mapState } from "vuex";

export default {
	data: function() {
		return {

		};
	},
	methods: {
/// Params: Object
/// checks to make sure that the object passed has completed all its custom fields. Supported objects: Order, Rate, Activity, RateParticipant
		validateCustomFields(object) {
			if (!object) { return true }
			var valid = true
			//Activity
			if (object.SelectedTimes) {
				object.SelectedTimes.forEach(time => {
					time.Rates.forEach(rate => {
						if (!this.validateCustomFields(rate)) {valid = false}
					})
				})
			}
			//Rate
			if (object.CustomFieldParticipants) {
				object.CustomFieldParticipants.forEach(participant => {
					participant.CustomFields.forEach(field => {
						if (!this.customFieldIsValid(field)) {
							valid = false;
						}
					})
				})
			}
			//Order && RateParticipant
			if (object.CustomFields) {
				object.CustomFields.forEach(field => {
					if (!this.customFieldIsValid(field)) {
						valid = false;
					}
				})
			} 
			return valid
		},
/// Params: CustomField
/// checks to make sure either the field has a value, or it's not required
		customFieldIsValid(field) {
			return (this.valueForCustomField(field) || !field.IsRequired)
		},
/// Params: CustomField
/// Determines what the value of the CustomField is (returns false if none) based on the ResponseTypeKey
		valueForCustomField(field) {
			switch (field.ResponseTypeKey) {
				case 1: return field.Response_Boolean ? "Agreed" : false
				case 2: case 4:
					if (!field.Response_Text || field.Response_Text == "") return false
					return field.Response_Text || false
				case 3:
					if (!field.CustomFieldResponses || !field.Selected_ClientLocationCustomFieldResponseKeys || !field.Selected_ClientLocationCustomFieldResponseKeys[0]) { return false }
					var key = field.Selected_ClientLocationCustomFieldResponseKeys[0];
					var response = field.CustomFieldResponses.find(r => key == r.ClientLocationCustomFieldResponseKey)
					if (response) { return response.ResponseLabel }
					return false
				default: return "No Response"
			}
		},
/// Params: Array
/// reduces the Rates array down to a single list of Rate CustomFieldParticipant arrays
		filterCustomFields(array) {
			return array.reduce((prev, current) => {
				return prev.concat((current.CustomFieldParticipants ? current.CustomFieldParticipants : []))
			}, [])
		},
/// Params: Object
/// returns a list of the object's CustomFields filtered to only return ones with a value
		validCustomFields(object) {
			return object.CustomFields.filter(f => this.valueForCustomField(f))
		}
    },
	computed: {
// Returns true if the entire order has all required custom fields complete		
		allFieldsAnswered() {
			if (!this.validateCustomFields(this.order)) { return false }
			if (!this.allActivitiesAnswered) { return false }
			return true
		},
// Returns true if the each activity on the order has all required custom fields complete
		allActivitiesAnswered() {
			var allValid = true
			this.customFieldActivities.forEach((activity => {
				if(!this.validateCustomFields(activity)) {allValid = false}
			}))
			return allValid
		},
// Returns all activities from Individual and Packages that have custom fields
		customFieldActivities() {
			var results = []
			this.order.Individual && this.order.Individual.forEach((item) => {
				item.Activities.forEach((activity) => {
					//Make sure we dont add this activity more than once
					var activityFound = false
					if (activity.CustomFields && activity.CustomFields.length) {
						results.push(activity)
					} else {
						activity.SelectedTimes.forEach((time) => {
							if (time.Rates.find((rate) => rate.CustomFieldParticipants && rate.CustomFieldParticipants.length && !activityFound)) {
								activityFound = true
								results.push(activity)
							}
						})
					}
				})
			})
			this.order.Packages && this.order.Packages.forEach((item) => {
				item.Activities.forEach((activity) => {
					//Make sure we dont add this activity more than once
					var activityFound = false
					if (activity.CustomFields && activity.CustomFields.length) {
						results.push(activity)
					} else {
						activity.SelectedTimes.forEach((time) => {
							if (time.Rates.find((rate) => rate.CustomFieldParticipants && rate.CustomFieldParticipants.length && !activityFound)) {
								activityFound = true
								results.push(activity)
							}
						})
					}
				})
			})
			return results
		},
// Returns all custom fields on the root order object
		customFields() {
			return this.order.CustomFields;
		},
	}
};
